/**************************************************************************************************/
/*   File: /src/app/egov/egov.module.ts                                                           */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { LoggerModule } from 'ngx-logger';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { EGovAuthModule } from '@siag/ng6p-egov-authentication';

import { environment } from '../../environments/environment';
import { EgovNavbarComponent } from './egov.navbar.component';
import { EgovService } from './egov.service';

/**
 * The component module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EGovAuthModule.forRoot(),
    LoggerModule.forRoot({ level: environment.logLevel })
  ],
  declarations: [
    EgovNavbarComponent
  ],
  exports: [
    EgovNavbarComponent
  ],
  providers: [
    EgovService
  ]
})
export class EgovModule { }
